import type {
  StorageFacilityStopTimingCargoConfigCreateApiData,
  StorageFacilityStopTimingCargoConfigCreateApiResponses,
  StorageFacilityStopTimingCargoConfigListApiData,
  StorageFacilityStopTimingCargoConfigListApiResponses,
  StorageFacilityStopTimingCargoConfigPatchApiData,
  StorageFacilityStopTimingCargoConfigPatchApiResponses,
  StorageFacilityStopTimingGetApiData,
  StorageFacilityStopTimingGetApiResponses,
  StorageFacilityStopTimingListApiData,
  StorageFacilityStopTimingListApiResponses,
  StorageFacilityStopTimingPatchApiData,
  StorageFacilityStopTimingPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getStorageFacilityStopTimingUrls = {
  getPaginatedStorageFacilityStopTimings: dataEndpoint<
    StorageFacilityStopTimingListApiData,
    StorageFacilityStopTimingListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('storage-facility-stop-timings/', queryParams)
  }),
  getStorageFacilityStopTiming: dataEndpoint<
    StorageFacilityStopTimingGetApiData,
    StorageFacilityStopTimingGetApiResponses
  >({
    getUrl: ({ storageFacilityStopTimingId }) => apiUrl(`storage-facility-stop-timings/${storageFacilityStopTimingId}/`)
  }),
  patchStorageFacilityStopTiming: responseEndpoint<
    StorageFacilityStopTimingPatchApiData,
    StorageFacilityStopTimingPatchApiResponses
  >({
    getUrl: ({ storageFacilityStopTimingId }) =>
      apiUrl(`storage-facility-stop-timings/${storageFacilityStopTimingId}/`),
    getBody: (data) => data
  }),
  getPaginatedStorageFacilityStopTimingCargoConfigs: dataEndpoint<
    StorageFacilityStopTimingCargoConfigListApiData,
    StorageFacilityStopTimingCargoConfigListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('storage-facility-stop-timing-cargo-configs/', queryParams)
  }),
  postStorageFacilityStopTimingCargoConfig: responseEndpoint<
    StorageFacilityStopTimingCargoConfigCreateApiData,
    StorageFacilityStopTimingCargoConfigCreateApiResponses
  >({
    getUrl: () => apiUrl('storage-facility-stop-timing-cargo-configs/'),
    getBody: (data) => data
  }),
  patchStorageFacilityStopTimingCargoConfig: responseEndpoint<
    StorageFacilityStopTimingCargoConfigPatchApiData,
    StorageFacilityStopTimingCargoConfigPatchApiResponses
  >({
    getUrl: ({ storageFacilityStopTimingCargoConfigId }) =>
      apiUrl(`storage-facility-stop-timing-cargo-configs/${storageFacilityStopTimingCargoConfigId}/`),
    getBody: (data) => data
  })
};
